import './style.sass';
import { memo } from 'react';
import { DeepReadonly } from '@zajno/common/types';
import { CampaignData } from 'common/types/models/campaign';
import { Table } from '../common/Table';
import { CampaignRow } from './CampaignRow';
import { UserRoles } from 'src/types/user';
import { useBreakpointType } from 'app/services/breakpoints';

type Props = {
    campaigns: ReadonlyArray<DeepReadonly<CampaignData>>,
    userRole: UserRoles,
};

const tableColumnsByRole = {
    [UserRoles.Admin]: {
        Desktop: ['Order #', 'Artist name', 'Song name', 'Order date', 'Release date', 'Status'],
        Tablet: ['Order #', 'Artist name', 'Song name', 'Order date', 'Status'],
    },
    [UserRoles.Default]: {
        Desktop: ['Artist/Song name', 'Order #', 'Order date', 'Plan', 'Status'],
        Tablet: ['Artist/Song name', 'Order #', 'Order date', 'Plan', 'Status'],
    },
};

export const CampaignsTable = memo(({ campaigns, userRole }: Props) => {
    const { type } = useBreakpointType();

    if (!campaigns || !campaigns.length) {
        return null;
    }

    return (
        <Table columns={tableColumnsByRole[userRole][type]} className={`campaigns-table campaigns-table--${userRole}`}>
            {campaigns.map(campaign => (
                <CampaignRow
                    key={campaign.id}
                    campaignId={campaign.id}
                    userRole={userRole}
                />
            ))}
        </Table>
    );
});

